import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13d11eef"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "zone-map relative" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "darkstore-zone-management-map",
  class: "w-full h-full overflow-auto"
}, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "w-full h-full absolute top-0 confirm-bg"
}
const _hoisted_4 = { class: "absolute custom-assign-confirm p-4 shadow-lg border rounded-lg bg-white" }
const _hoisted_5 = { class: "text-lg text-black font-bold" }
const _hoisted_6 = { class: "flex justify-center gap-4 mt-4" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.confirm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createTextVNode(_toDisplayString(_ctx.$t(_ctx.confirm.isAssign ? 'zones.do_you_want_to_un_assign' : 'zones.do_you_want_to_assign', [_ctx.confirm.zone.name])) + " ", 1),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", {
                  class: "primary h-10 px-5 ml-4",
                  disabled: _ctx.loading,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addAssignUnAssignHandler(_ctx.confirm.polygon, _ctx.confirm.zone, _ctx.confirm.isAssign)))
                }, [
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.$t('buttons.processing')), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_ctx.$t(_ctx.confirm.isAssign ? 'buttons.yesUnassign' : 'buttons.yesAssign')), 1)
                      ], 64))
                ], 8, _hoisted_7),
                _createElementVNode("button", {
                  disabled: _ctx.loading,
                  class: "tertiary h-10 px-5 ml-4",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.confirm = null))
                }, _toDisplayString(_ctx.$t('cancel')), 9, _hoisted_8)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}